import { render, staticRenderFns } from "./FilterBoxSpec.vue?vue&type=template&id=04a78cb8"
import script from "./FilterBoxSpec.vue?vue&type=script&lang=js"
export * from "./FilterBoxSpec.vue?vue&type=script&lang=js"
import style0 from "./FilterBoxSpec.vue?vue&type=style&index=0&id=04a78cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports